import * as React from 'react';
import { TableWrapper, ColumnWrapper } from './Table_SC';
import { TableRow } from './TableRow/TableRow';

export type RowItem = React.ReactChild;
export type Row = RowItem[];
export interface CustomColumnWidth {
  index: number;
  minWidth: number;
  maxWidth: string;
  center?: boolean;
}

export interface Props {
  columns: readonly string[];
  rows: Row[];
  /**
   * For typography, allows styling of the last column
   */
  useNameAsTextStyle?: boolean;
  /**
   * Allows to specify certain columns widths
   */
  customColumnWidth?: CustomColumnWidth[];
  /**
   * Makes the column certain sizes across the table
   */
  uniformWidth?: number;
  isPropTable?: boolean;
}

export const Table: React.FC<Props> = React.memo((props) => {
  const { customColumnWidth = [], columns, rows, useNameAsTextStyle, isPropTable } = props;
  let { uniformWidth } = props;
  const columnRef = React.useRef<HTMLDivElement>(null);
  const [columnWidths, setColumnWidths] = React.useState<number[]>([]);

  if (isPropTable) {
    uniformWidth = 175;
  }

  const mappedColumns = columns.map((column, i) => {
    let width = uniformWidth;
    let maxWidth = 'unset';
    let center = false;
    customColumnWidth?.forEach((customColumn) => {
      if (customColumn.index === i) {
        width = customColumn.minWidth;
        maxWidth = customColumn.maxWidth + 'px';
        center = customColumn.center || false;
      }
    });
    return (
      <span key={i} style={{ padding: '12px 0px', minWidth: width, maxWidth, flex: 1, textAlign: center ? 'center' : 'left' }}>
        {column}
      </span>
    );
  });

  React.useLayoutEffect(() => {
    let tempColumnWidths = [];
    if (columnRef.current) {
      for (let i = 0; i < columnRef.current.children.length; i++) {
        tempColumnWidths.push(columnRef.current.children[i].clientWidth);
      }

      setColumnWidths(tempColumnWidths);
    }
  }, []);

  const mappedRows = rows.map((row, i) => {
    const title = row[0].toString();

    return (
      <React.Fragment key={i}>
        {title && title !== 'dangerouslySetInnerHTML' && !title.includes('_') ? (
          <TableRow
            columnWidths={columnWidths}
            rows={row}
            extraEnabled={!(customColumnWidth || uniformWidth)}
            useNameAsTextStyle={useNameAsTextStyle}
            isPropTable={isPropTable}
          />
        ) : (
          ''
        )}
      </React.Fragment>
    );
  });

  return (
    <TableWrapper>
      <ColumnWrapper className="kxi-text-600 kxi-text-small" ref={columnRef}>
        {mappedColumns}
      </ColumnWrapper>
      {mappedRows}
    </TableWrapper>
  );
});
